var render = function () {
  var _vm$data$item, _vm$data$item$product, _vm$data$item2, _vm$data$item3, _vm$data$item3$produc, _vm$data$item4, _vm$data$item5, _vm$data$item5$produc, _vm$data$item6, _vm$data$item7, _vm$data$item7$produc, _vm$data$item8;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "amendSpecificationDialogBox"
  }, [_c('el-dialog', {
    attrs: {
      "center": "",
      "title": _vm.data.title ? _vm.data.title : '修改规格',
      "visible": _vm.amendSpecificationDialog
    },
    on: {
      "close": _vm.amendSpecificationDialogClose
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form,
      "label-position": "left",
      "label-width": "110px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": (_vm.data.title == '修改规格' ? ((_vm$data$item = _vm.data.item) === null || _vm$data$item === void 0 ? void 0 : (_vm$data$item$product = _vm$data$item.productManageDTO) === null || _vm$data$item$product === void 0 ? void 0 : _vm$data$item$product.firstCategoryId) == 2 : ((_vm$data$item2 = _vm.data.item) === null || _vm$data$item2 === void 0 ? void 0 : _vm$data$item2.firstCategoryId) == 2) ? _vm.data.title == '修改规格' ? ((_vm$data$item3 = _vm.data.item) === null || _vm$data$item3 === void 0 ? void 0 : (_vm$data$item3$produc = _vm$data$item3.productManageDTO) === null || _vm$data$item3$produc === void 0 ? void 0 : _vm$data$item3$produc.serviceSpecificationOne) || '--' : ((_vm$data$item4 = _vm.data.item) === null || _vm$data$item4 === void 0 ? void 0 : _vm$data$item4.serviceSpecificationOne) || '--' : '规格'
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.specificationsChange
    },
    model: {
      value: _vm.specificationsModel,
      callback: function ($$v) {
        _vm.specificationsModel = $$v;
      },
      expression: "specificationsModel"
    }
  }, _vm._l(_vm.specificationOptions, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    });
  }), 1)], 1), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.specificationsTwoShow,
      expression: "specificationsTwoShow"
    }],
    attrs: {
      "label": (_vm.data.title == '修改规格' ? ((_vm$data$item5 = _vm.data.item) === null || _vm$data$item5 === void 0 ? void 0 : (_vm$data$item5$produc = _vm$data$item5.productManageDTO) === null || _vm$data$item5$produc === void 0 ? void 0 : _vm$data$item5$produc.firstCategoryId) == 2 : ((_vm$data$item6 = _vm.data.item) === null || _vm$data$item6 === void 0 ? void 0 : _vm$data$item6.firstCategoryId) == 2) ? _vm.data.title == '修改规格' ? ((_vm$data$item7 = _vm.data.item) === null || _vm$data$item7 === void 0 ? void 0 : (_vm$data$item7$produc = _vm$data$item7.productManageDTO) === null || _vm$data$item7$produc === void 0 ? void 0 : _vm$data$item7$produc.serviceSpecificationTwo) || '--' : ((_vm$data$item8 = _vm.data.item) === null || _vm$data$item8 === void 0 ? void 0 : _vm$data$item8.serviceSpecificationTwo) || '--' : '产品'
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: _vm.form.specificationsTwo,
      callback: function ($$v) {
        _vm.$set(_vm.form, "specificationsTwo", $$v);
      },
      expression: "form.specificationsTwo"
    }
  }, _vm._l(_vm.specificationsTwoOptions, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    });
  }), 1)], 1), _c('el-form-item', {
    attrs: {
      "label": "数量"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 1,
      "max": 10,
      "label": "描述文字"
    },
    model: {
      value: _vm.form.quantity,
      callback: function ($$v) {
        _vm.$set(_vm.form, "quantity", $$v);
      },
      expression: "form.quantity"
    }
  })], 1)], 1), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "noBtn",
    on: {
      "click": _vm.amendSpecificationDialogClose
    }
  }, [_vm._v("取 消")]), _c('el-button', {
    staticClass: "subBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.subBtnClick
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }